import React from 'react';
import { HONEYPOT_FIELD } from '../../services/login/signup_public';

// Off-screen rather than display:none or `hidden`: many bots skip fields hidden that way.
// A negative left offset can't be scrolled to in an LTR page; the clip, opacity and
// pointer-events keep it invisible and unclickable even if a layout change ever put it in view.
const OFFSCREEN: React.CSSProperties = {
    position: 'absolute', left: '-10000px', top: 0, width: '1px', height: '1px', overflow: 'hidden',
    clip: 'rect(0 0 0 0)', clipPath: 'inset(50%)', whiteSpace: 'nowrap', opacity: 0, pointerEvents: 'none'
};

// #region HoneypotField
/**
 * Bot trap for sign-up. People never see it, can't tab to it, and screen readers
 * skip it; form-filling bots see a plausible "Company website" field and fill it.
 * Anything typed here makes the backend fake a successful sign-up and create
 * nothing. Keep it inside the <form> so bots find it.
 */
export const HoneypotField: React.FunctionComponent<{ value: string; onChange: (value: string) => void }> = ({ value, onChange }): React.ReactElement => (
    <div style={OFFSCREEN} aria-hidden="true">
        <label htmlFor={HONEYPOT_FIELD}>Company website</label>
        <input id={HONEYPOT_FIELD} name={HONEYPOT_FIELD} type="text" placeholder="https://" tabIndex={-1} autoComplete="off"
            value={value} onChange={(ev) => onChange(ev.target.value)} />
    </div>
);
